module.exports = __webpack_public_path__ + "static/logistic-blog-img-2-9ce5a39d4442d413b9bfdb06d7c3ae52.jpg";